module.exports = __webpack_public_path__ + "assets/img/b158-mq.svg";